import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {Button, Modal, Radio} from 'antd';
import axios from 'axios';
import PaymentForm from "../PaymentForm";

import {Configs} from '../../dashboard/api';


const options = [
    { label: '$10', value: '10' },
    { label: '$15', value: '15' },
    { label: '$20', value: '20' },
  ];
class OrderConfirm extends Component {
    state = {  }
    constructor(props){
        super(props);
        this.state={
            text :'Burrito Bar ',
            tipModal : false,
            paymentModal: false,
            tipValue: '15',
            
        }
        
    }
    onChangeTip = e => {
        console.log('radio3 checked', e.target.value);
        this.setState({
          tipValue: e.target.value,
        });
      };
    toggleTipModal = () => {
        this.setState(prevState => ({
          tipModal: !prevState.tipModal,
        }));
        console.log(this.state.tipModal)
      };
      togglePaymentModal = () => {
        this.setState(prevState => ({
          paymentModal: !prevState.paymentModal,
        }));
      };
      handleTipSelection = e => {
          this.togglePaymentModal();
          this.toggleTipModal();
          console.log('payment should open')
      }
      payTip = () => {

        this.togglePaymentModal();
      }
    componentDidMount(){

        const dataID = async() =>{
    
            try {
            const result = await axios.get(Configs.waittime)
               this.setState( {text : result.data.waittimes[0].name})
            //  console.log(result.data.waittimes[0].name)
          }
            catch (error) {
              console.log(error.message);

            }
          }
          dataID();

          const that = this;
          let sqPaymentScript = document.createElement("script");
          sqPaymentScript.src = "https://js.squareupsandbox.com/v2/paymentform";
          sqPaymentScript.type = "text/javascript";
          sqPaymentScript.async = false;
          sqPaymentScript.onload = () => {
            that.setState({
              loaded: true
            });
          };
          document.getElementsByTagName("head")[0].appendChild(sqPaymentScript);
        }
    
    render() { 
        return ( 
            <React.Fragment>
               <div className='order-page'>
               <div style={{marginBottom:'60px'}} className='menu-static-upper'>
               <Link to='/home'>
                   <span style={{left:'0'}} className='home-ico'>
                   <i className='fa fa-home'></i>
                   </span>
                   </Link>
                   </div>
                   <div className='gray-bold'>Order</div>
                   <div style={{lineHeight:'1'}} className='orange-bold'>Confirmed</div>

                   <div style={{padding: '30px 0px'}} className='orange-light'>
                       <span>Your order number is </span>
                       <span><b>12</b></span>
                   </div>
                   <div style={{padding: '30px 0px'}}>
                  <span className='gray'>
                  {this.state.text}</span>              
                   <span className='orange'></span>
                    
                   </div>

                   <div className='orange-light'>James Brandon / 81</div>
                   <div>
                        <Button onClick={() => this.toggleTipModal()} className='tip-btn'>
                            Tip
                        </Button>
                        <Modal
                            title="Select Tip"
                            visible={this.state.tipModal}
                            onOk={this.handleTipSelection}
                            onCancel={this.toggleTipModal}
                            bodyStyle={{display: 'flex', justifyContent:'center'}}
                            >
                            <Radio.Group
                                options={options}
                                onChange={this.onChangeTip}
                                value={this.state.tipValue}
                                optionType="button"
                                />
                        </Modal>
                        <Modal
                            title="Payment for tip"
                            visible={this.state.paymentModal}
                            onOk={this.payTip}
                            onCancel={this.togglePaymentModal}
                            bodyStyle={{display: 'flex', justifyContent:'center'}}
                            footer={null}
                            >

                            <div className='pay-box'>
                            {this.state.loaded && <PaymentForm tip={this.state.tipValue} paymentForm={window.SqPaymentForm} />}
                            <img style={{float:'right'}} height='' width='' src={require('../../assets/img/cards.png')}/> 
                            </div>
                            
                        </Modal>
                    </div>
                   <div className='bottom-btn'>
                        <Link to='/menu'>
                            <Button className='place-order'>
                            Place Another Order
                            </Button>
                        </Link>
                   </div>

               </div>  
            </React.Fragment>
         );
    }
}
 
export default OrderConfirm;